import { lazy } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'

import { useAuth } from './AuthProvider'

const Unauthorized = lazy(() => import('../pages/Unauthorized/Unauthorized.jsx'))

export default function RequireAuth({ allowedRoles }) {
  const { user, loading } = useAuth()
  const location = useLocation()

  if (loading) return null

  if (!user) {
    return <Unauthorized fromLocation={location} />
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to="/acces-interdit" state={{ from: location }} replace />
  }

  return <Outlet />
}
